/*
 * @Author: ZhaoDong
 * @Date: 2022-10-27 15:14:43
 * @LastEditors: ZhaoDong
 * @LastEditTime: 2022-10-29 23:31:12
 * @Description: 优惠券
 */
import { computed } from '@vue/composition-api'
import store from '@/store/'

export default () => {
  const computedData = {
    // 优惠券类型
    COUPON_TYPE: computed(() => (
      store.state.label.data.COUPON_ENUM?.COUPON_TYPE
    )),
    // 优惠券属性
    COUPON_PROPERTY: computed(() => (
      store.state.label.data.COUPON_ENUM?.COUPON_PROPERTY
    )),
     // 状态
    COUPON_STATE: computed(() => (
      store.state.label.data.COUPON_ENUM?.COUPON_STATE
    )),
    // 领取方式
    COUPON_WAY: computed(() => (
      store.state.label.data.COUPON_ENUM?.COUPON_WAY
    )),
    // 领取状态
    RECORD_STATE: computed(() => (
      store.state.label.data.COUPON_ENUM?.RECORD_STATE
    )),
    // 平台
    COUPON_PLAT: computed(() => (
      store.state.label.data.COUPON_ENUM?.COUPON_PLAT
    )),
    COUPON_TARGET: computed(() => {
      return {
        1: '所有用户',
        2: '新增注册用户',
        3: '指定用户'
      }
    }),
    // 互斥规则
    USE_RULE: computed(() => {
      return {
        1: '不可与其他优惠叠加使用',
      }
    }),
  }

  function showName(type, key) {
    return computedData?.[type]?.value[key] ?? '--'
  }

  return {
    ...computedData,
    showName
  }
}
